import React, { useCallback, useMemo, useState } from "react";
import ModelMediaView from "./ModelMediaView";
import IndexModelMediaContainer from "./ModelMediaContent/IndexModelMediaContainer";
import type { MediaImage } from "./ModelMediaContent/ImageInformation";

export type ModelMediaContainerProps = {
  selectedImg?: (img: MediaImage) => void;
};

const ModelMediaContainer = ({
  selectedImg = (_img: MediaImage) => {},
}: ModelMediaContainerProps) => {
  const [modal, setModal] = useState(false);
  const [nestedModal, setNestedModal] = useState(false);
  const [closeAll, setCloseAll] = useState(false);
  const [img, setImg] = useState<MediaImage>({ secure_url: "", filename: "" });

  const toggle = useCallback(() => setModal((m) => !m), []);
  const toggleNested = useCallback(() => {
    setNestedModal((n) => !n);
    setCloseAll(false);
  }, []);
  const toggleAll = useCallback(() => {
    setNestedModal((n) => !n);
    setCloseAll(true);
  }, []);

  const handleImageSelected = useCallback((image: MediaImage) => {
    setImg(image);
    setNestedModal(true);
    setCloseAll(false);
  }, []);

  const handleConfirmImageMedia = useCallback(() => {
    selectedImg(img);
    toggleAll();
  }, [img, selectedImg, toggleAll]);

  const ViewModel = useMemo(
    () => ({
      modal,
      nestedModal,
      closeAll,
      img,
      // actions
      toggle,
      toggleNested,
      toggleAll,
      handleImageSelected,
      handleConfirmImageMedia,
      // children
      MediaBrowser: (
        <IndexModelMediaContainer SelectedImage={handleImageSelected} />
      ),
    }),
    [
      modal,
      nestedModal,
      closeAll,
      img,
      toggle,
      toggleNested,
      toggleAll,
      handleImageSelected,
      handleConfirmImageMedia,
    ]
  );

  return <ModelMediaView {...ViewModel} />;
};

export default ModelMediaContainer;
